module.exports = __webpack_public_path__ + "img/bmcl_main1.3dfff59b.jpg";